import React from "react";

const HelpdeskIcon = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width="77.0464mm"
      height="20.8279mm"
      style={{
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        height: 25,
        width: 100,
        ...style,
      }}
      viewBox="0 0 4582.48 1238.78"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <style type="text/css" />
      </defs>
      <g id="Layer_x0020_1" className="Helpdesk-icon">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_2165634843968">
          <path
            className="fil0"
            d="M609.32 166.18l0 -35.25 -120.86 0 0 352.5c0,25.93 49.72,15.11 120.86,15.11l0 -261.86c7.2,-1.68 120.86,-64.12 120.86,40.29l0 221.57c149.29,0 120.86,25.74 120.86,-120.86 0,-47 0,-94 0,-141 135.32,-71.6 115.82,50.1 115.82,105.75 0,28.54 0.05,57.07 0,85.61 -0.14,84.24 -23.22,70.5 120.86,70.5l0 -261.86c0,-61.06 -40.63,-115.82 -100.71,-115.82 -90.43,0 -90.18,19.66 -151.07,60.43 -40.97,-61.18 -63.12,-60.43 -125.89,-60.43 -39.41,0 -73.03,30.67 -100.71,45.32z"
          />
          <path
            className="fil0"
            d="M-0 156.11c0,35.35 14.18,69.15 31.5,89.35 74.15,86.44 250.49,48.81 250.49,122.15 0,69.94 -151.93,44.05 -198.22,21.98 -30.87,-14.73 -68.36,-40.83 -83.78,-42.12l0 120.86c90.42,43.38 261.37,55.72 348.3,-4.2 86.04,-59.32 87.07,-180.76 10.37,-228.58 -76.42,-47.63 -191.5,-43.66 -218.38,-74.07 -26.14,-29.57 13.11,-65.8 61.14,-65.8 65.99,0 108.81,3.84 164.16,42.65 41.98,29.44 32.23,4.4 32.23,-93.01 0,-30.72 -157.32,-45.32 -176.25,-45.32 -56.07,0 -112.85,14.88 -148.15,38.17 -41.23,27.2 -73.42,62.47 -73.42,117.94z"
          />
          <path
            className="fil0"
            d="M2991.2 926.57c0,-68.66 26.72,-110.78 95.68,-110.78 21.66,0 27.29,5.87 45.32,10.07 0,41.94 -0.31,84.01 0.04,125.93 0.37,44.61 12.22,70.46 -80.62,70.46 -47.03,0 -60.43,-47.5 -60.43,-95.68zm141 -176.25c-38.32,-8.93 -89.24,-41.85 -159.57,-8.5 -107.16,50.81 -125.09,173.27 -89.18,277.39 35.72,103.61 147.53,117.55 226.29,66.18 14.3,-9.33 4.28,-7.94 22.46,-12.79l0 35.25c71.13,0 120.86,10.82 120.86,-15.11l0 -493.5 -120.86 0 0 151.07z"
          />
          <path
            className="fil0"
            d="M4194.73 1107.85l120.86 0c0,-70.18 -15.08,-142.67 35.25,-156.1 5.47,20.47 34.28,59.04 47.34,78.55l48.33 77.56 135.96 0c-7.49,-32.16 -109.09,-160.71 -135.96,-211.5 21.37,-31.9 109.51,-125.15 125.89,-156.1 -33.67,0 -67.31,0.08 -100.97,-0.26 -37.05,-0.37 -33.27,-2.59 -52.38,23.15l-103.47 128.18 0 -292.07 -120.86 0 0 508.6z"
          />
          <path
            className="fil0"
            d="M1289.14 382.71c0,-51.79 79.98,-55.39 125.89,-55.39l0 75.54c-31.5,8.42 -14.85,20.14 -75.54,20.14 -30.03,0 -50.35,-10.27 -50.35,-40.29zm-90.64 -246.75l0 90.64c45.45,0 67.89,-25.18 125.89,-25.18 84.96,0 125.55,54.83 60.82,55.78 -24.09,0.35 -28.78,1.49 -46.65,3.71 -84.43,10.49 -170.27,26.44 -170.27,131.87 0,33.22 9.85,55.99 26.49,74.23 12.93,14.19 43.94,31.72 64.65,36.13 29.51,6.27 58.83,3.81 85.97,-3.75 47.97,-13.36 45.84,-29.75 69.64,-36.11l0 35.25c71.13,0 120.86,10.82 120.86,-15.11l0 -226.61c0,-45.96 -13,-80.75 -39.31,-101.68 -51.19,-40.71 -124.27,-34.28 -187.29,-34.28 -45.4,0 -73.85,14.29 -110.78,15.11z"
          />
          <path
            className="fil0"
            d="M3600.52 871.18l-146.04 0c0.98,-43.92 28.77,-64.73 72.2,-68.42 45.62,-3.88 72.81,22.43 73.84,68.42zm-266.89 30.21c0,60.87 1,120.52 57.38,164.18 69.96,54.18 117.94,47.32 204.47,47.32 22.32,0 120.86,-13.44 120.86,-40.28l-2.23 -43.42c-3.4,-34.47 11.16,-55.68 -28.17,-32.9 -91.93,53.26 -229.3,47.31 -231.45,-49.57l266.9 0c0,-68.36 2.81,-127.83 -48.87,-177.74 -95.35,-92.11 -338.88,-40.02 -338.88,132.42z"
          />
          <path
            className="fil0"
            d="M3776.77 851.03c0,142.16 187.3,99.89 221.57,151.07 -12.79,54.91 -124.76,26.91 -159.11,13.08 -20.68,-8.33 -42.56,-26.53 -62.46,-28.19l0 100.71c119.4,27.82 37.68,25.18 191.36,25.18 68.84,0 151.07,-47.39 151.07,-115.82 0,-60.96 -21.36,-92.6 -85.53,-110.86 -23.07,-6.57 -46.94,-9.77 -71.1,-14.51 -32.72,-6.42 -59.9,-7.5 -59.9,-35.78 0,-38.87 107.03,-25.02 141.88,-10.95 19.4,7.83 40.99,24.52 59.54,26.06l0 -95.67c-98.52,-52.13 -327.32,-37.59 -327.32,95.67z"
          />
          <path
            className="fil0"
            d="M1973.99 40.28l0 90.64 -45.32 0 0 80.57 45.32 0c0,63.45 -7.57,207.13 22.01,249.92 37.82,54.7 150.36,45.89 209.63,32.08l0 -80.57c-38.54,0 -110.79,48.57 -110.79,-70.5l0 -130.93 110.79 0 0 -80.57c-136.33,0 -110.79,25.1 -110.79,-105.75 -71.13,0 -120.86,-10.82 -120.86,15.11z"
          />
          <path
            className="fil0"
            d="M1636.6 483.43c0,25.93 49.72,15.11 120.86,15.11l0 -246.75c24.28,-2.02 50.56,-15.11 80.57,-15.11 28.91,0 38.23,5.04 70.5,5.04l0 -110.79c-97.82,0 -80.4,3.03 -151.07,50.36l0 -50.36 -120.86 0 0 352.5z"
          />
        </g>
        <g id="_2165634849008" className="helpdesk-Color">
          <path
            className="fil1"
            d="M1641.47 1102.82l0.1 -481.07 -120.45 -0.01 -0.34 176.68c-31.08,4 -168.89,6.69 -185.54,-2.77l-0.82 -176.25 -125.85 0 0 488.46 125.89 0c0,-54.49 -5.78,-147.23 -0.52,-196.9 3.08,-29.08 12.75,-19.65 81.08,-19.63 33.57,0.01 67.14,0 100.72,0 0,56.96 0.8,114.5 -0.18,171.39 -0.79,45.87 -6.51,46.26 40.16,45.44 22.52,-0.39 72.29,3.38 85.74,-5.34z"
          />
          <path
            className="fil1"
            d="M2548.06 1007.14c0,-160.71 -21.32,-186.32 70.5,-186.32 93.04,0 85.95,157.19 31.09,192.23 -17.57,11.22 -101.59,24.47 -101.59,-5.91zm0 -236.68c0,-44.48 11.42,-30.21 -95.68,-30.21 -22.96,0 3.85,-6.15 -25.18,0l0 498.53 120.86 0 0 -146.03c28.42,2.37 149.43,73.87 235.84,-61.27 27.62,-43.19 36.1,-113.97 23.2,-177.63 -19.53,-96.38 -92.9,-145.73 -185.46,-120.6 -32.68,8.87 -50.45,31.04 -73.57,37.21z"
          />
          <path
            className="fil1"
            d="M1913.56 805.71c43.79,0 85.61,-3.63 85.61,65.47l-146.03 0c6.02,-12.54 10.53,-65.47 60.43,-65.47zm-181.29 110.79c0,196.42 185.93,220.53 324.36,188.39 24.14,-5.6 36.93,-12.19 58.36,-17.18l0 -100.71c-46.84,3.9 -33.43,40.29 -161.15,40.29 -89,0 -90.85,-60.01 -100.71,-80.57l266.89 0 0 -60.43c0,-232.9 -387.75,-209.56 -387.75,30.21z"
          />
          <path
            className="fil1"
            d="M599.25 845.99l-79.49 46.48c-31.92,26.84 -0.43,59.92 13.77,84.71 15.61,27.24 29.88,53.51 45.65,80.24 24.59,41.67 40.98,29.51 78.79,8.45 21.75,-12.12 57.35,-38.55 84.13,-40.3 60.19,-3.93 152.33,24.31 176.84,-41.16 0.84,-2.22 3.49,-11.1 3.68,-11.43 11.48,-20.76 37.11,-1.98 47.34,-38.27 5.33,-18.92 1.93,-43.41 1.93,-63.53 42.74,-3.56 32.94,-57.31 25.18,-90.64 -45.77,-10.66 -121.3,-5.04 -171.21,-5.04 0,49.39 12.23,120.86 -70.5,120.86 -80.85,0 -60.43,-120.19 -60.43,-181.29 -20.47,1.71 -56.87,26.41 -72.79,38 -29.3,21.33 -22.89,46.86 -22.89,92.93z"
          />
          <polygon
            className="fil1"
            points="2316.63,599.25 2206.44,599.25 2204.55,1102.29 2318.76,1102.47 "
          />
          <path
            className="fil1"
            d="M720.1 705c0,71.06 -16.61,166.18 40.28,166.18 6.03,0 24.29,-8.5 28.41,-11.88 20.51,-16.9 11.88,-74.92 11.88,-114.01 36.47,15.07 168.41,-19.49 210.48,16.13 19.13,16.2 16.13,31.68 16.13,64.44 22.56,-5.26 34.85,-16.26 53.87,-26.71 56.94,-31.3 48.51,-40.1 21.67,-89.12 -8.35,-15.25 -16.54,-29.51 -25.43,-45.06 -53.52,-93.53 -48.3,-90.93 -127.84,-42.73 -27.57,16.7 -34.98,27.81 -78.16,27.59 -33.92,-0.18 -68.08,-3.87 -94.1,6.61 -16.74,6.74 -57.18,30.22 -57.18,48.57z"
          />
        </g>
      </g>
    </svg>
  );
};

export default HelpdeskIcon;
